import { useMemo } from 'react'
import dayjs from 'dayjs'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { useOrionIdentifier, useOrionDomainQuery } from '../../../../../api/coreData'
import buildActivitySummaryRequest from './buildRequest'
import transformActivitySummaryResponse from './transformResponse'

export default function useActivitySummary (config) {
  const { clientId } = useAppContext()
  const { data: identity, isFetching: isFetchingIdentity } = useOrionIdentifier(clientId)

  // Intentionally frozen at mount — acceptable for typical session lengths
  const asOfDate = useMemo(
    () => dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
    []
  )

  const requestJson = useMemo(() => {
    if (!identity?.entity) return null
    return JSON.stringify(
      buildActivitySummaryRequest(config, {
        entity: identity.entity,
        entityIds: identity.entityIds,
        asOfDate
      })
    )
  }, [config, identity, asOfDate])

  const request = useMemo(
    () => requestJson ? JSON.parse(requestJson) : null,
    [requestJson]
  )

  const {
    data: rawResponse,
    isFetching: isFetchingData,
    error
  } = useOrionDomainQuery('reporting/scope', clientId, request, {
    enabled: !!request
  })

  const { rows, dateRange } = useMemo(() => {
    if (!rawResponse) return { rows: [], dateRange: null }
    return transformActivitySummaryResponse(rawResponse, config)
  }, [rawResponse, config])

  const isFetching = isFetchingIdentity || isFetchingData

  return { rows, dateRange, isFetching, error, config, clientId }
}
